export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

export const FETCH_CATEGORY_REQUEST = 'FETCH_CATEGORY_REQUEST';
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS';
export const FETCH_CATEGORY_FAILURE = 'FETCH_CATEGORY_FAILURE';

export const UPDATE_CATEGORIES_REQUEST = 'UPDATE_CATEGORIES_REQUEST';
export const UPDATE_CATEGORIES_SUCCESS = 'UPDATE_CATEGORIES_SUCCESS';
export const UPDATE_CATEGORIES_FAILURE = 'UPDATE_CATEGORIES_FAILURE';

export const DELETE_CATEGORIES_REQUEST = 'DELETE_CATEGORIES_REQUEST';
export const DELETE_CATEGORIES_SUCCESS = 'DELETE_CATEGORIES_SUCCESS';
export const DELETE_CATEGORIES_FAILURE = 'DELETE_CATEGORIES_FAILURE';

export const CLEAR_CATEGORY_ERRORS = 'CLEAR_CATEGORY_ERRORS';
export const CLEAR_CATEGORY_SUCCESS = 'CLEAR_CATEGORY_SUCCESS';